export function isNumber(valor: any): valor is number {
  return typeof valor === 'number';
}
